import { TControlName } from '@infotech-soe/metaschema';

import { FormControlViewModelType } from '../view-model/FormControlViewModel';
import {
  FormControls,
  FormUpdateViewModel,
  FormViewModel,
} from '../view-model/FormViewModel';

const clearForm = (form: FormViewModel): FormUpdateViewModel => {
  const controls: FormControls = {};
  const args: Record<TControlName, any> = {};

  Object.entries(form.controls).forEach(([name, model]) => {
    if (model.hasValue) {
      if (
        model.type === FormControlViewModelType.CHECKBOX &&
        !model.allowNull
      ) {
        controls[name] = {
          ...model,
          value: false,
        };
      } else {
        controls[name] = { ...model, value: null };
      }
    }
  });

  Object.keys(form.args).forEach(key => {
    args[key] = null;
  });

  return { controls, args, apiVars: form.apiVars, triggered: true };
};

export default clearForm;
